import { Capacitor } from '@capacitor/core'
import type { DashboardData } from './types'

interface WidgetContact {
  id: string
  name: string
  phone: string | null
  daysOverdue: number | null
  frequency: string
}

interface WidgetData {
  contacts: WidgetContact[]
  updatedAt: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let widgetBridgeInstance: any = null

async function getWidgetBridge() {
  if (!Capacitor.isNativePlatform()) return null
  if (!widgetBridgeInstance) {
    const mod = await import('capacitor-widget-bridge')
    widgetBridgeInstance = (mod as Record<string, unknown>).WidgetBridge ?? mod.default
  }
  return widgetBridgeInstance
}

const WIDGET_GROUP = 'group.com.aime.crm'
const WIDGET_DATA_KEY = 'widget_reach_out_contacts'

export async function syncWidgetData(dashboard: DashboardData): Promise<void> {
  const bridge = await getWidgetBridge()
  if (!bridge) return

  const widgetContacts: WidgetContact[] = dashboard.overdueContacts.slice(0, 5).map((c) => ({
    id: c.id,
    name: [c.firstName, c.lastName].filter(Boolean).join(' '),
    phone: c.phone,
    daysOverdue: c.daysOverdue,
    frequency: c.contactFrequency,
  }))

  const widgetData: WidgetData = {
    contacts: widgetContacts,
    updatedAt: new Date().toISOString(),
  }

  await bridge.setItem({
    key: WIDGET_DATA_KEY,
    value: JSON.stringify(widgetData),
    group: WIDGET_GROUP,
  })

  await bridge.reloadAllTimelines()
}
